import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgHealth = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="m19.298 5.261-5.649 3.262V2h-4v6.523L4 5.261 2 8.726l5.648 3.261L2 15.248l2 3.465 5.649-3.261v6.523h4v-6.523l5.649 3.261 2-3.465-5.648-3.261 5.648-3.261-2-3.465Z"
      fill={color}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHealth);
export default ForwardRef;
